import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';

export default function FakeTickets() {
  const [activeTab, setActiveTab] = useState('wizz');
  const [loading, setLoading] = useState(false);

  // Wizz Air Form
  const [wizzForm, setWizzForm] = useState({
    kodi_bilete: '',
    titulli: 'MR',
    emri: '',
    mbiemri: '',
    origjina: '',
    destinacion: '',
    nr_fluturimit: '',
    data_nisjes: new Date(),
    data_mbrritjes: new Date(),
    bagazhe_kabine: '1/40x30x20',
    bagazhe_chek_in: '0',
    seat: '-',
    cmimi: '',
  });

  // GP Aviation Form
  const [gpForm, setGpForm] = useState({
    booking_no: '',
    customer_nr: '',
    invoice_no: '',
    booking_date: new Date(),
    flight_type: 'direct',
    num_flights: 1,
    flights: [
      { origin: '', destination: '', flight_no: '', class: 'Y', date: '', departure: '', arrival: '', airline: 'GP AVIATION' },
      { origin: '', destination: '', flight_no: '', class: 'Y', date: '', departure: '', arrival: '', airline: 'GP AVIATION' },
      { origin: '', destination: '', flight_no: '', class: 'Y', date: '', departure: '', arrival: '', airline: 'GP AVIATION' },
    ],
    passengers: [
      { prefix: 'MR', lastname: '', firstname: '', baggage: '20kg', ticket_nr: '', price: '', tax: '' }
    ],
  });

  const generateWizzPdf = async () => {
    if (!wizzForm.emri || !wizzForm.mbiemri) {
      toast.error('Plotëso emrin dhe mbiemrin!');
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/fake-tickets/wizz', {
        ...wizzForm,
        data_nisjes: wizzForm.data_nisjes.toISOString(),
        data_mbrritjes: wizzForm.data_mbrritjes.toISOString(),
      }, { responseType: 'blob' });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `WizzAir_${wizzForm.mbiemri}_${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('PDF u gjenerua me sukses!');
    } catch (error) {
      toast.error('Gabim gjatë gjenerimit të PDF!');
    } finally {
      setLoading(false);
    }
  };

  const generateGpPdf = async () => {
    if (!gpForm.passengers[0].lastname || !gpForm.passengers[0].firstname) {
      toast.error('Plotëso të dhënat e pasagjerit!');
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/fake-tickets/gp', {
        ...gpForm,
        booking_date: gpForm.booking_date.toISOString().split('T')[0],
      }, { responseType: 'blob' });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `GPAviation_${gpForm.passengers[0].lastname}_${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('PDF u gjenerua me sukses!');
    } catch (error) {
      toast.error('Gabim gjatë gjenerimit të PDF!');
    } finally {
      setLoading(false);
    }
  };

  const addPassenger = () => {
    if (gpForm.passengers.length >= 9) {
      toast.error('Maksimumi 9 pasagjerë!');
      return;
    }
    setGpForm({
      ...gpForm,
      passengers: [...gpForm.passengers, { prefix: 'MR', lastname: '', firstname: '', baggage: '20kg', ticket_nr: '', price: '', tax: '' }]
    });
  };

  const removePassenger = (index) => {
    if (gpForm.passengers.length <= 1) return;
    setGpForm({
      ...gpForm,
      passengers: gpForm.passengers.filter((_, i) => i !== index)
    });
  };

  const updatePassenger = (index, field, value) => {
    const updated = [...gpForm.passengers];
    updated[index][field] = value;
    setGpForm({ ...gpForm, passengers: updated });
  };

  const updateFlight = (index, field, value) => {
    const updated = [...gpForm.flights];
    updated[index][field] = value;
    setGpForm({ ...gpForm, flights: updated });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
          <span className="text-3xl">🎫</span>
          Bileta Fiktive
        </h1>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="flex border-b">
          <button
            onClick={() => setActiveTab('wizz')}
            className={`flex-1 py-4 px-6 font-semibold transition-colors ${
              activeTab === 'wizz'
                ? 'bg-pink-600 text-white'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2">✈️</span> Wizz Air
          </button>
          <button
            onClick={() => setActiveTab('gp')}
            className={`flex-1 py-4 px-6 font-semibold transition-colors ${
              activeTab === 'gp'
                ? 'bg-blue-900 text-white'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2">🛫</span> GP Aviation
          </button>
        </div>

        {/* Wizz Air Form */}
        {activeTab === 'wizz' && (
          <div className="p-6">
            <div className="bg-gradient-to-r from-pink-500 to-pink-600 text-white p-4 rounded-lg mb-6">
              <h2 className="text-xl font-bold">✈️ Wizz Air Ticket Generator</h2>
              <p className="text-pink-100 text-sm">Gjenero biletë fiktive Wizz Air</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Kodi i Biletës</label>
                <input
                  type="text"
                  value={wizzForm.kodi_bilete}
                  onChange={(e) => setWizzForm({ ...wizzForm, kodi_bilete: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="SRB8FE"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Titulli</label>
                <select
                  value={wizzForm.titulli}
                  onChange={(e) => setWizzForm({ ...wizzForm, titulli: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                >
                  <option value="MR">MR</option>
                  <option value="MRS">MRS</option>
                  <option value="MS">MS</option>
                  <option value="CHD">CHD</option>
                  <option value="INF">INF</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Emri</label>
                <input
                  type="text"
                  value={wizzForm.emri}
                  onChange={(e) => setWizzForm({ ...wizzForm, emri: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="JOHN"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Mbiemri</label>
                <input
                  type="text"
                  value={wizzForm.mbiemri}
                  onChange={(e) => setWizzForm({ ...wizzForm, mbiemri: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="DOE"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Origjina</label>
                <input
                  type="text"
                  value={wizzForm.origjina}
                  onChange={(e) => setWizzForm({ ...wizzForm, origjina: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="TIA"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Destinacioni</label>
                <input
                  type="text"
                  value={wizzForm.destinacion}
                  onChange={(e) => setWizzForm({ ...wizzForm, destinacion: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="MXP"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Nr. Fluturimit</label>
                <input
                  type="text"
                  value={wizzForm.nr_fluturimit}
                  onChange={(e) => setWizzForm({ ...wizzForm, nr_fluturimit: e.target.value.toUpperCase() })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="W6 4301"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Data/Ora Nisjes</label>
                <DatePicker
                  selected={wizzForm.data_nisjes}
                  onChange={(date) => setWizzForm({ ...wizzForm, data_nisjes: date })}
                  showTimeSelect
                  dateFormat="dd/MM/yyyy HH:mm"
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Data/Ora Mbërritjes</label>
                <DatePicker
                  selected={wizzForm.data_mbrritjes}
                  onChange={(date) => setWizzForm({ ...wizzForm, data_mbrritjes: date })}
                  showTimeSelect
                  dateFormat="dd/MM/yyyy HH:mm"
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Bagazh Kabine</label>
                <input
                  type="text"
                  value={wizzForm.bagazhe_kabine}
                  onChange={(e) => setWizzForm({ ...wizzForm, bagazhe_kabine: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="1/40x30x20"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Bagazh Check-in</label>
                <input
                  type="text"
                  value={wizzForm.bagazhe_chek_in}
                  onChange={(e) => setWizzForm({ ...wizzForm, bagazhe_chek_in: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="0"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Ulëse</label>
                <input
                  type="text"
                  value={wizzForm.seat}
                  onChange={(e) => setWizzForm({ ...wizzForm, seat: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="-"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Çmimi (€)</label>
                <input
                  type="number"
                  step="0.01"
                  value={wizzForm.cmimi}
                  onChange={(e) => setWizzForm({ ...wizzForm, cmimi: e.target.value })}
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-pink-500"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={generateWizzPdf}
                disabled={loading}
                className="px-8 py-3 bg-pink-600 text-white rounded-lg font-semibold hover:bg-pink-700 disabled:opacity-50 flex items-center gap-2 mx-auto"
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  '📄'
                )}
                Gjenero PDF Wizz Air
              </button>
            </div>
          </div>
        )}

        {/* GP Aviation Form */}
        {activeTab === 'gp' && (
          <div className="p-6">
            <div className="bg-gradient-to-r from-blue-800 to-blue-900 text-white p-4 rounded-lg mb-6">
              <h2 className="text-xl font-bold">🛫 GP Aviation Ticket Generator</h2>
              <p className="text-blue-200 text-sm">Gjenero biletë fiktive GP Aviation</p>
            </div>

            {/* Booking Info */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <h3 className="font-semibold text-gray-700 mb-3">📋 Informacioni i Rezervimit</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Booking No.</label>
                  <input
                    type="text"
                    value={gpForm.booking_no}
                    onChange={(e) => setGpForm({ ...gpForm, booking_no: e.target.value })}
                    className="w-full border rounded-lg px-3 py-2"
                    placeholder="GP12345"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Customer Nr.</label>
                  <input
                    type="text"
                    value={gpForm.customer_nr}
                    onChange={(e) => setGpForm({ ...gpForm, customer_nr: e.target.value })}
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Invoice No.</label>
                  <input
                    type="text"
                    value={gpForm.invoice_no}
                    onChange={(e) => setGpForm({ ...gpForm, invoice_no: e.target.value })}
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Booking Date</label>
                  <DatePicker
                    selected={gpForm.booking_date}
                    onChange={(date) => setGpForm({ ...gpForm, booking_date: date })}
                    dateFormat="dd.MM.yyyy"
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>
              </div>
            </div>

            {/* Flight Type */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <h3 className="font-semibold text-gray-700 mb-3">✈️ Lloji i Fluturimit</h3>
              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={() => setGpForm({ ...gpForm, flight_type: 'direct', num_flights: 1 })}
                  className={`px-6 py-2 rounded-lg font-medium transition-all ${
                    gpForm.flight_type === 'direct'
                      ? 'bg-blue-900 text-white'
                      : 'bg-white border-2 border-gray-300 text-gray-600 hover:border-blue-500'
                  }`}
                >
                  🔵 Direkt
                </button>
                <button
                  type="button"
                  onClick={() => setGpForm({ ...gpForm, flight_type: 'transit', num_flights: 2 })}
                  className={`px-6 py-2 rounded-lg font-medium transition-all ${
                    gpForm.flight_type === 'transit'
                      ? 'bg-blue-900 text-white'
                      : 'bg-white border-2 border-gray-300 text-gray-600 hover:border-blue-500'
                  }`}
                >
                  🔄 Transit
                </button>
              </div>
            </div>

            {/* Flights */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <h3 className="font-semibold text-gray-700 mb-3">🛫 Fluturimet</h3>
              
              {[0, 1, 2].map((index) => (
                (index === 0 || (gpForm.flight_type === 'transit' && index < gpForm.num_flights)) && (
                  <div key={index} className="bg-white p-4 rounded-lg mb-3 border">
                    <h4 className="font-medium text-gray-600 mb-2">Fluturimi {index + 1}</h4>
                    <div className="grid grid-cols-2 md:grid-cols-8 gap-2">
                      <div>
                        <label className="block text-xs text-gray-500">Origjina</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].origin}
                          onChange={(e) => updateFlight(index, 'origin', e.target.value.toUpperCase())}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="TIA"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Destinacion</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].destination}
                          onChange={(e) => updateFlight(index, 'destination', e.target.value.toUpperCase())}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="IST"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Nr. Fluturimit</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].flight_no}
                          onChange={(e) => updateFlight(index, 'flight_no', e.target.value.toUpperCase())}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Klasa</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].class}
                          onChange={(e) => updateFlight(index, 'class', e.target.value)}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Data</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].date}
                          onChange={(e) => updateFlight(index, 'date', e.target.value)}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="20DEC"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Nisja</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].departure}
                          onChange={(e) => updateFlight(index, 'departure', e.target.value)}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="10:00"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Mbërritja</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].arrival}
                          onChange={(e) => updateFlight(index, 'arrival', e.target.value)}
                          className="w-full border rounded px-2 py-1 text-sm"
                          placeholder="12:30"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500">Airline</label>
                        <input
                          type="text"
                          value={gpForm.flights[index].airline}
                          onChange={(e) => updateFlight(index, 'airline', e.target.value)}
                          className="w-full border rounded px-2 py-1 text-sm"
                        />
                      </div>
                    </div>
                  </div>
                )
              ))}

              {gpForm.flight_type === 'transit' && gpForm.num_flights < 3 && (
                <button
                  type="button"
                  onClick={() => setGpForm({ ...gpForm, num_flights: 3 })}
                  className="text-blue-600 text-sm font-medium hover:text-blue-700"
                >
                  + Shto Fluturimin 3
                </button>
              )}
              {gpForm.flight_type === 'transit' && gpForm.num_flights === 3 && (
                <button
                  type="button"
                  onClick={() => setGpForm({ ...gpForm, num_flights: 2 })}
                  className="text-red-600 text-sm font-medium hover:text-red-700"
                >
                  - Hiq Fluturimin 3
                </button>
              )}
            </div>

            {/* Passengers */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <div className="flex justify-between items-center mb-3">
                <h3 className="font-semibold text-gray-700">👥 Pasagjerët</h3>
                <button
                  type="button"
                  onClick={addPassenger}
                  className="px-3 py-1 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                >
                  + Shto Pasagjer
                </button>
              </div>

              {gpForm.passengers.map((passenger, index) => (
                <div key={index} className="bg-white p-4 rounded-lg mb-3 border relative">
                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removePassenger(index)}
                      className="absolute top-2 right-2 text-red-500 hover:text-red-700 font-bold"
                    >
                      ✕
                    </button>
                  )}
                  <h4 className="font-medium text-gray-600 mb-2">Pasagjeri {index + 1}</h4>
                  <div className="grid grid-cols-2 md:grid-cols-7 gap-2">
                    <div>
                      <label className="block text-xs text-gray-500">Prefix</label>
                      <select
                        value={passenger.prefix}
                        onChange={(e) => updatePassenger(index, 'prefix', e.target.value)}
                        className="w-full border rounded px-2 py-1 text-sm"
                      >
                        <option value="MR">MR</option>
                        <option value="MRS">MRS</option>
                        <option value="MS">MS</option>
                        <option value="CHD">CHD</option>
                        <option value="INF">INF</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Mbiemri</label>
                      <input
                        type="text"
                        value={passenger.lastname}
                        onChange={(e) => updatePassenger(index, 'lastname', e.target.value.toUpperCase())}
                        className="w-full border rounded px-2 py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Emri</label>
                      <input
                        type="text"
                        value={passenger.firstname}
                        onChange={(e) => updatePassenger(index, 'firstname', e.target.value.toUpperCase())}
                        className="w-full border rounded px-2 py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Bagazh</label>
                      <input
                        type="text"
                        value={passenger.baggage}
                        onChange={(e) => updatePassenger(index, 'baggage', e.target.value)}
                        className="w-full border rounded px-2 py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Ticket Nr.</label>
                      <input
                        type="text"
                        value={passenger.ticket_nr}
                        onChange={(e) => updatePassenger(index, 'ticket_nr', e.target.value)}
                        className="w-full border rounded px-2 py-1 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Çmimi</label>
                      <input
                        type="text"
                        value={passenger.price}
                        onChange={(e) => updatePassenger(index, 'price', e.target.value)}
                        className="w-full border rounded px-2 py-1 text-sm"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500">Taksa</label>
                      <input
                        type="text"
                        value={passenger.tax}
                        onChange={(e) => updatePassenger(index, 'tax', e.target.value)}
                        className="w-full border rounded px-2 py-1 text-sm"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 text-center">
              <button
                onClick={generateGpPdf}
                disabled={loading}
                className="px-8 py-3 bg-blue-900 text-white rounded-lg font-semibold hover:bg-blue-800 disabled:opacity-50 flex items-center gap-2 mx-auto"
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  '📄'
                )}
                Gjenero PDF GP Aviation
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}